import { z } from 'zod';

export const NavLinkImageDetails = z.object({
  target_id: z.string().or(z.number()).nullable(),
  alt: z.string(),
  title: z.string(),
  width: z.string().or(z.number()).nullable(),
  height: z.string().or(z.number()).nullable(),
});

export type NavLinkImageDetails = z.infer<typeof NavLinkImageDetails>;
